import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import UnlinkedTransferAccountsPage, { getDefaultUI } from "components/pages/UnlinkedTransferAccountsPage";
import AddUnlinkedTransferAccountForm from "components/workflows/AddUnlinkedTransferAccountWorkflow/classes/AddUnlinkedTransferAccountForm";
import Classes, { Account } from "model";


/**
 * @name CaptureMiscAddTransferAccountMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Misc" (abi22).
 */
export default function CaptureMiscAddTransferAccountMain(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const defaultUnlinkedAcc = BCMSDefaultModel.unlinkedAccount();
    const hasConsumerAccounts = Account.hasConsumerAccounts(branding);
    
    const uiData = { 
        isActive: true,
        step: 1,
        form: AddUnlinkedTransferAccountForm.init({
            accountNickname: defaultUnlinkedAcc.accountOwnerFirstName,
            accountOwnerType: hasConsumerAccounts ? "personal" : "business",
            firstNameOfAccountOwner: defaultUnlinkedAcc.accountOwnerFirstName,
            lastNameOfAccountOwner: defaultUnlinkedAcc.accountOwnerLastName,
            accountType: defaultUnlinkedAcc.subtype,
            accountNumber: "1500306800",
            confirmAccountNumber: "1500306800"
        }, branding)
    };

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "addUnlinkedTransferAccountModal" ], uiData)
    .submit();

    return <UnlinkedTransferAccountsPage ui={ ui } />;
}